export default {
  vgn: {
    name: 'Vegan',
    emoji: '🌱',
  },
  vgt: {
    name: 'Vegetarian',
    emoji: '🥬',
  },
  gf: {
    name: 'Gluten free',
  },
  df: {
    name: 'Dairy free',
  },
  hal: {
    name: 'Halal',
  },
  'h&s': {
    name: 'Spicy',
    emoji: '🌶',
  },
};
